/*
 * Copyright (c) Kalaora 2022.
 * Author: fharold
 *
 * hilo-oauth-manager
 * PageTitle.tsx
 */

import React from 'react';
import HiloReactComponent from "./HiloReactComponent";

interface Props {
}

interface State {
}

export default class PageTab extends HiloReactComponent<Props, State> {
    constructor(props: Props, state: State) {
        super(props, state);

        this.state = {
        }
    }

    /**
     * render
     * @returns {any}
     */
    public render() {
        return <div className={"page-tab"}>
            {this.props.children}
        </div>
    }
}